import { useContext } from "react";
import { ConfigurationContext } from "../contexts/Configuration";

export const useConfiguration = () => {
  const configuration = useContext(ConfigurationContext);
  return configuration;
};
